document.addEventListener('turbolinks:load', function () {
    if ($('.permit_applications.new, .permit_applications.create, .permit_applications.update, .permit_applications.edit').length === 0) {
        return false
    }

    // do not want to trigger this js if we are working on project edit form
    // it should only serve the permit applications form
    if ($('.permit_applications-form-section').length === 0) {
        return false
    }

    var permitInformationTab = $('#permitInformationTab')
    var createProjectBtn = $(permitInformationTab).find('.create-project-now-btn')
    var nextStepBtn = $(permitInformationTab).find('.next-step-btn')
    $(document).on('change', '#project_organization_id', function () {
        var value = $(this).val()
        var optionWithValue = $(this).find(`option[value=${value}]`)
        var permitFeeVisibility = $(optionWithValue).attr('data-permit_fee_visibility')

        if (permitFeeVisibility === "true") {
            $(createProjectBtn).addClass('d-none')
            $(nextStepBtn).removeClass('d-none')
        } else {
            $(createProjectBtn).removeClass('d-none')
            $(nextStepBtn).addClass('d-none')
        }
    })
});